import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  fechaDesde: Yup.string().required(),
  fechaHasta: Yup.string().required()
})
